import {Component, EventEmitter, Input, Output, OnInit} from '@angular/core';
import {Router} from '@angular/router';
@Component({
  selector: 'app-bottom-menu',
  templateUrl: './bottom-menu.component.html',
  styleUrls: ['./bottom-menu.component.scss']
})
export class BottomMenuComponent implements OnInit {
  @Input() activeMenu;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  isCheckEnabled = true;
  newOne = false;
  constructor(private router: Router) { }
  ngOnInit(): void {
    const temp =  localStorage.getItem('newKarpoohse');
    if (temp !== null) {
      this.newOne = true;
    }
    this.checkIfChecqueIsEnabled();
  }
  showPopUp() {
    this.notifyParent.emit();
  }
  chequeButtonAction() {
    this.isCheckEnabled ? this.router.navigate(['/cheque']) :  this.showPopUp()
  }
  checkIfChecqueIsEnabled() {
    let actionsStorage = localStorage.getItem('chequeAvailbleActions');
    if (actionsStorage) {
      const actionsList = JSON.parse(actionsStorage);
      actionsList.forEach(element => {
        if (element.title === 'مدیریت چک') {
          this.isCheckEnabled = element.active
        }
      });
    }
  }
}
